export default __webpack_public_path__ + "static/media/onboarding1.dcd8cab7.png";